import React, { useState, useEffect } from 'react';
import { DeliveryService } from '../Services/DeliveryService';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';
import { format_display_fancy_notime_withDay, toInt, format_without_time } from '../Utils';
import { Table, TableHead, TableRow, TableCell, Typography, Grid, Paper, TableBody, Fade, CircularProgress, FormControl, MenuItem, InputLabel, Select, OutlinedInput } from '@material-ui/core';
import EnhancedTableToolbar from '../components/EnhancedTableToolbar';
import XLSX from 'xlsx';
import { ProductService } from '../Services/ProductService';

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(3),
        overflow: 'auto'
    },
    formControl: {
        margin: theme.spacing(1),
        marginTop: theme.spacing(3),
        minWidth: 200,
        marginLeft: theme.spacing(2),
        [theme.breakpoints.up('md')]: {
            marginLeft: theme.spacing(2),
        },
    }
  })
);

function Indent(props) {
    const classes = useStyles();
    const [date, setDate] = useState(moment().add(1, "day").format(format_without_time));
    const dateOptions = [ <MenuItem key={1} value={moment().add(1, "day").format(format_without_time)}>{moment().add(1, "day").format(format_display_fancy_notime_withDay)}</MenuItem>,  <MenuItem key={2} value={moment().add(2, "day").format(format_without_time)}>{moment().add(2, "day").format(format_display_fancy_notime_withDay)}</MenuItem>];
    const [fetch, setFetch] = useState(false);
    const [indent, setIndent] = useState([]);
    const [rows, setRows] = useState([]);
    const [sheet2, setSheet2] = useState([]);
    const [pNames, setPNames] = useState([]);
    const [products, setProducts] = useState([]);

    useEffect(() => {
        props.setTitle('View Indents');
        return () => {props.setTitle('') }
    }, []);

    useEffect(() => {
        ProductService.getProductList()
        .then((data) => {
            let products = data.products.filter(p => p.status !== -1);
            setProducts(products);
        })
        .catch((error) => {
            console.log(error);
        })
    }, []);
    
    useEffect(() => {
        props.isLoading(true);
        setFetch(true);
        if(products.length > 0){
            DeliveryService.getIndent(date)
            .then((data) => {
                console.log(data);
                setIndent(data.indent);
                let rows = [];
                let productList = new Set(data.indent.map(s => s.product_id));
                let index = 0;
                let sheet2 = [];
                let pNames = [];
                productList.forEach((product_id) => {
                    let qty = data.indent.filter(s => s.product_id === product_id).reduce((accumulator, currentValue) => accumulator + toInt(currentValue.qty), 0);
                    if(qty > 0){
                        let pMaster = products.filter(p => p.id === product_id)[0];
                        pNames.push(pMaster.name);
                        let percentage = parseFloat(pMaster.indent_inc_percentage);
                        let totalQty = Math.ceil((qty * (1 + (percentage / 100))));
                        let crate_size = toInt(pMaster.crate_size);
                        let no_of_crates = crate_size === 0 ? "-" : Math.ceil(totalQty / crate_size);
                        sheet2.push({
                            index: ++index,
                            product: pMaster.name,
                            qty: qty,
                            inc_percentage: percentage.toFixed(1),
                            total_qty: totalQty,
                            crate_size: crate_size,
                            no_of_crates: no_of_crates
                        })
                        rows.push(
                            <TableRow key={index}>
                                <TableCell>
                                    <Typography variant="subtitle1" color="textPrimary">{index}</Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography variant="subtitle1" color="textPrimary">{pMaster.name}</Typography>
                                </TableCell>
                                <TableCell align="right">
                                    <Typography variant="subtitle1" color="textPrimary">{qty}</Typography>
                                </TableCell>
                                <TableCell align="right">
                                    <Typography variant="subtitle1" color="textPrimary">{percentage.toFixed(1)}</Typography>
                                </TableCell>
                                <TableCell align="right">
                                    <Typography variant="subtitle1" color="textPrimary">{totalQty}</Typography>
                                </TableCell>
                            </TableRow>
                        );
                    }
                });
                setPNames(pNames);
                setSheet2(sheet2);

                //Other rows
                products
                .filter(p => !productList.has(p.id))
                .forEach(p => {
                    let percentage = parseFloat(p.indent_inc_percentage);
                    let crate_size = toInt(p.crate_size);
                    let no_of_crates = "-";
                    sheet2.push({
                        index: ++index,
                        product: p.name,
                        qty: 0,
                        inc_percentage: percentage.toFixed(1),
                        total_qty: 0,
                        crate_size: crate_size,
                        no_of_crates: no_of_crates
                    });
                    rows.push(
                        <TableRow key={p.id}>
                            <TableCell>
                                <Typography variant="subtitle1" color="textPrimary">{index}</Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant="subtitle1" color="textPrimary">{p.name}</Typography>
                            </TableCell>
                            <TableCell align="right">
                                <Typography variant="subtitle1" color="textPrimary">{0}</Typography>
                            </TableCell>
                            <TableCell align="right">
                                <Typography variant="subtitle1" color="textPrimary">{percentage.toFixed(1)}</Typography>
                            </TableCell>
                            <TableCell align="right">
                                <Typography variant="subtitle1" color="textPrimary">{0}</Typography>
                            </TableCell>
                        </TableRow>
                    );
                });
                setRows(rows);
                props.isLoading(false);
                setFetch(false);
            })
            .catch((error) => {
                props.isLoading(false);
                setFetch(false);
            });
        }
    }, [products, date]);

    const exportReport = () => {
        if(indent && indent.length > 0){
            let sheetname = 'Store Indent Report';
            let sheetname2 = 'Total Indent';
            let exportData = [], exportData2 = [], routeExport = [];

            let pList = pNames;
            let title = ["Sl No", "Store", "Route", "Agent"];
            title.push.apply(title, pList);
            exportData.push(title);
            exportData2 = [["Index", "Product", "Indent", "Indent Inc %", "Final Indent", "Crate Size", "No Of Crates"]];
            let sList = new Set(indent.map(s => s.user_id));
            let index = 0;
            sList.forEach((store_id) => {
                let ss = indent.filter(s => s.user_id === store_id);
                let row = [++index, ss[0].store_name, ss[0].route_id, ss[0].agent_name];
                
                pList.forEach((p) => {
                    let s = ss.filter(sss => sss.product_name === p);
                    let qty = s.length === 1 ? s[0].qty : 0;
                    row.push(qty);
                });
                exportData.push(row);
            });

            sheet2.forEach((row) => {
                exportData2.push([row.index, row.product, row.qty, row.inc_percentage, row.total_qty, row.crate_size, row.no_of_crates]);
            })

            if(exportData){
                const wb = XLSX.utils.book_new();
                const wsAll = XLSX.utils.aoa_to_sheet(exportData);
                const wsAll2 = XLSX.utils.aoa_to_sheet(exportData2);
                XLSX.utils.book_append_sheet(wb, wsAll, sheetname );
                XLSX.utils.book_append_sheet(wb, wsAll2, sheetname2 );

                //Adding sheets per Agent
                let routeList = new Set(indent.map(s => s.agent_name));

                let productList = new Set(indent.map(s => s.product_id));

                routeList.forEach(route => {
                    routeExport = [["Index", "Product", "Indent"]];
                    products
                    .filter(p => productList.has(p.id))
                    .forEach((p, index) => {                    
                        let qL = indent.filter(i => i.product_id === p.id && i.agent_name === route);
                        
                        let qty = 0;
                        qty = qL.reduce(function(accumulator, currentValue) {
                            return accumulator + toInt(currentValue.qty);
                        }, qty);
                        routeExport.push([ ++index, p.name, qty ]);
                    });
                    const wsAllRoute = XLSX.utils.aoa_to_sheet(routeExport);
                    XLSX.utils.book_append_sheet(wb, wsAllRoute, route);
                });

                XLSX.writeFile(wb, sheetname + ".xlsx");
            }
        } else {
            props.showSnackBar('Nothing to export', 'error');
        }
    }

    return (
        <div className="Home">
				<div className="">
				<Grid container spacing={2} style={{marginTop: 20}}>
                    <Grid item lg={12} xs={12}>
                        <Paper className={classes.root}>
                            {/* <Typography variant="subtitle2" style={{fontSize: 18}}>View Indents</Typography> */}
                            <EnhancedTableToolbar title={
                                <FormControl variant="outlined" className={classes.formControl}>
                                    <InputLabel
                                        htmlFor="outlined-date-simple"
                                    >
                                        Schedule Date
                                    </InputLabel>
                                    <Select
                                        value={moment(date).format(format_without_time)}
                                        onChange={(e) => {
                                            setDate(e.target.value);
                                        }}
                                        input={
                                        <OutlinedInput
                                            labelWidth={105}
                                            name="Schedule Date"
                                            id="outlined-date-simple"
                                        />
                                        }
                                    >
                                        {dateOptions}
                                    </Select>
                                </FormControl>
                            } exportReport={exportReport}/>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant="subtitle2" style={{fontSize: 18}} color="textPrimary">Product</Typography>
                                        </TableCell>
                                        <TableCell align="right">
                                            <Typography variant="subtitle2" style={{fontSize: 18}} color="textPrimary">Quantity</Typography>
                                        </TableCell>
                                        <TableCell align="right">
                                            <Typography variant="subtitle2" style={{fontSize: 18}} color="textPrimary">Increment %</Typography>
                                        </TableCell>
                                        <TableCell align="right">
                                            <Typography variant="subtitle2" style={{fontSize: 18}} color="textPrimary">Final Qty</Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows}
                                </TableBody>
                            </Table>
                            <Fade
                                in={fetch}
                                style={{
                                    transitionDelay: fetch ? '10ms' : '0ms'
                                }}
                                unmountOnExit
                                >
                                <CircularProgress style={{marginTop: 20}}/>
                            </Fade>
                        </Paper>
                    </Grid>
				</Grid>
            </div>
        </div>
      );
};

export default Indent;